module.exports = __webpack_public_path__ + "static/media/crow_dropping_roti_river.14acd10d.gif";